// extracted by mini-css-extract-plugin
export default {"container":"Avisos_container__BYpM0","avisos":"Avisos_avisos__ECRhW"};